<template>
    <div class="carousel-3d-controls">
        <a href="#" class="prev" @click.prevent="parent.goPrev()"
           :class="{ disabled: !parent.isPrevPossible }"
           aria-label="Previous slide">
            <span class="icon icon-arrow-left"></span>
        </a>
        <a href="#" class="next" @click.prevent="parent.goNext()"
           :class="{ disabled: !parent.isNextPossible }"
           aria-label="Next slide">
            <span class="icon icon-arrow-right"></span>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'controls',
        props: {
            /**
             * Width in pixels of the navigation buttons
             */
            width: {
                type: [String, Number],
                default: 50
            },
            /**
             * Height in pixels of the navigation buttons
             */
            height: {
                type: [String, Number],
                default: 60
            },
            /**
             * Text content of the navigation prev button
             */
            prevHtml: {
                type: String,
                default: '&lsaquo;'
            },
            /**
             * Text content of the navigation next button
             */
            nextHtml: {
                type: String,
                default: '&rsaquo;'
            }
        },
        data () {
            return {
                parent: this.$parent
            }
        }
    }
</script>

<style scoped>
    .carousel-3d-controls {
        position: absolute;
        top: 46.5%;
        height: 0;
        margin-top: -30px;
        left: 0;
        width: 100%;
        z-index: 1000;
    }
    .next, .prev {
        width: 60px;
        position: absolute;
        z-index: 1010;
        font-size: 1.5em;
        color: #333;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        text-decoration: none;
        top: 0;
        background-color: rgba(255, 255, 255, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .next:hover, .prev:hover {
        cursor: pointer;
    }
    .prev {
        left: 0;
        text-align: left;
        padding-left: 10px;
        width: 3em;
        background-image: linear-gradient(to right, rgba(255,255,255,1), rgba(255,255,255,0.9), rgba(255,255,255,0.1));
    }
    .next {
        right: 0;
        text-align: right;
        padding-right: 10px;
        width: 3em;
        background-image: linear-gradient(to left, rgba(255,255,255,1), rgba(255,255,255,0.9), rgba(255,255,255,0.1));
    }
    .disabled {
        opacity: 0.2;
        cursor: default;
    }
    .disabled:hover {
        cursor: default;
        opacity: 0.2;
    }

</style>